import dayjs from 'dayjs';
import { IntlComponent } from 'react-intl';

export const monthFirstDate = dayjs().startOf('month');
export const listStartDate = dayjs().subtract(1, 'day').startOf('day');
export const listEndDate = dayjs().endOf('day');

export const datePickerFormat = 'MM/DD/YYYY';
export const datePickerShortFormat = 'MM/YYYY';
export const timePickerFormat = 'HH:mm';
export const defaultTimePickerFormat = '00:00';
export const monthFormatOptions: IntlComponent.DateTimeFormatProps = {
	year: 'numeric',
	month: '2-digit',
};
export const dateFormatOptions: IntlComponent.DateTimeFormatProps = {
	day: 'numeric',
	year: 'numeric',
	month: '2-digit',
};
export const dateTimeFormatOptions: IntlComponent.DateTimeFormatProps = {
	day: 'numeric',
	year: 'numeric',
	month: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
};
export const pageSize = 20;
export const defaultCountry = 'US';
export const contentDispositionHeader: string = 'Content-Disposition';

export const notApplicableValue = 'N/A';

export const fullNameRegex: RegExp = /^[a-zA-Z\s]+\s+[a-zA-Z]+\s*$/;

export const CanadianFrenchlocale = 'fr-CA';



// WEBPACK FOOTER //
// ./src/constants/core.constants.ts